import { mapState, mapActions } from "vuex";
import Papa from "papaparse";
import CommonService from "../src/services/commonService";
import { Promise, resolve, reject } from "q";

export const CommonMixin = {
	data() {
		return {
			map: []
		};
	},
	computed: {
		...mapState("CommonStore", ["idNameMap", "storeDetailsProcessing", "storeProcessingCompleted"]),
		store_details_processing: {
      get() {
        return this.storeDetailsProcessing;
      },
      set(val) {
        this.$store.commit("CommonStore/updateStoreDetailsProcessing", val);
      }
    },
    store_processing_completed: {
      get() {
        return this.storeProcessingCompleted;
      },
      set(val) {
        this.$store.commit("CommonStore/updateStoreProcessingCompleted", val);
      }
    },
	},
	methods: {
		...mapActions("CommonStore", ["getCategories"]),
		getBasicsFromMap(basics, id) {
			const basicsMap = {
				country: this.isChildPresent(id, "regions", this.locations)
					? "region"
					: "outlet",
				region: this.isChildPresent(id, "subregions", this.locations)
					? "subregion"
					: "outlet",
				subregion: "outlet",
				outlet:
					this.$route.name == "Location"
						? "category"
						: this.$route.name == "forecastLocation"
						? "date"
						: "",
				department: this.isChildPresent(id, "categories", this.categories)
					? "category"
					: "product",
				category: this.isChildPresent(id, "subcategories", this.categories)
					? "subcategory"
					: "product",
				subcategory: "product",
				product: "date",
				date: "date"
			};
			return basicsMap[basics];
		},
		getBasics(basics, id, basicsFrom) {
			let result = {};
			result.id = id;
			result.route = this.$route.name;
			result.basicsFrom = basicsFrom;
			result.previousBasics = basics;
			if (basics == "date") {
				if (this.$route.name == "forecastLocation") {
					result.previousBasics = "outlet"; // if date is basics its previous basics should be outlet
				} else {
					result.previousBasics = "product";
				}
			}
			if (basicsFrom == "dropdown") {
				result.currentBasics = basics;
			} else if (basicsFrom == "table") {
				result.currentBasics = this.getBasicsFromMap(basics, id);
			}
			return result;
		},
		getFilter(result, filter, filterIds) {
			// let currentBasics = result.currentBasics;
			// let from = result.basicsFrom;
			// let previousBasics = result.previousBasics;
			// if (from == "table") {
			// 	if (previousBasics == filter) return filterIds;
			// 	else return [];
			// } else if (from == "dropdown" && currentBasics == filter) {
			// 	return filterIds;
			// } else {
			// 	return [];
			// }
			 return this.basicsInfo.id;
		},
		categoryPageLocationFilters(locBasicsInCatPage, filter, filterIds) {
			return locBasicsInCatPage == filter ? filterIds : [];
		},
		getAllFilters(isConsolidated, result) {
			return   result.route != "Report" // added department, categories, subcategories, products key, when current route is not report
				? {
					outlets:
					this.isCategoryPage || this.isCentralKitchenPage
						? this.categoryPageLocationFilters(
								this.locBasicsInCatPage,
								"outlet",
								this.filterLocIds
						  )
						: this.filterLocIds.length ? this.getFilter(result, "outlet", this.filterLocIds) : [],
						
						departments: this.filterLocIds.length ? this.getFilter(
							result,
							"department",
							this.filterCatIds
						) : [],
						categories: this.filterLocIds.length ? this.getFilter(result, "category", this.filterCatIds) : [],
						subcategories: this.filterLocIds.length ? this.getFilter(
							result,
							"subcategory",
							this.filterCatIds
						) : [],
						products: this.filterLocIds.length ? this.getFilter(result, "product", this.filterCatIds) : []
				  }
				: {
						countries:
							this.isCategoryPage || this.isCentralKitchenPage
								? this.categoryPageLocationFilters(
										this.locBasicsInCatPage,
										"country",
										this.filterLocIds
								  )
								: this.getFilter(result, "country", this.filterLocIds),
						regions:
							this.isCategoryPage || this.isCentralKitchenPage
								? this.categoryPageLocationFilters(
										this.locBasicsInCatPage,
										"region",
										this.filterLocIds
								  )
								: this.getFilter(result, "region", this.filterLocIds),
						subregions:
							this.isCategoryPage || this.isCentralKitchenPage
								? this.categoryPageLocationFilters(
										this.locBasicsInCatPage,
										"subregion",
										this.filterLocIds
								  )
								: this.getFilter(result, "subregion", this.filterLocIds),
						outlets:
							this.isCategoryPage || this.isCentralKitchenPage
								? this.categoryPageLocationFilters(
										this.locBasicsInCatPage,
										"outlet",
										this.filterLocIds
								  )
								: this.getFilter(result, "outlet", this.filterLocIds)
				  };
		},
		isChildPresent(id, child, arr) {
			// takes id of parent and name of child and an array of the heirarchy of the fields
			// if a child is present the function return true,
			function searchChildField(arr) {
				return arr.some(obj => {
					if (obj.id == id) {
						if (child in obj) {
							// console.log("length of ", child, obj[child].length);
							return obj[child].length;
						}
					}
					return Object.keys(obj).some(key => {
						if (Array.isArray(obj[key])) {
							return searchChildField(obj[key]);
						}
					});
				});
			}

			return searchChildField(arr) ? true : false;
		},
		getChildren(id, child, arr) {
			if (Array.isArray(arr)) {
				for (let obj of arr) {
					if (obj.id === id) {
						return obj[child];
					}
					for (let key in obj) {
						if (Array.isArray(obj[key])) {
							const result = this.getChildren(id, child, obj[key]);
							if (result !== undefined) {
								return result;
							}
						}
					}
				}
			}
		},
		getIdNameMap(unmappedArr) {
			if (this.idNameMap.length) {
				return this.idNameMap;
			} else {
				const map = this.mapkeyName(unmappedArr);
				this.$store.commit("CommonStore/ID_NAME_MAP", map);
				return map;
			}
		},
		mapkeyName(unmappedArr) {
			if (unmappedArr.length) {
				unmappedArr.map(obj => {
					this.map.push({
						name: obj.name,
						id: obj.id
					});
					Object.keys(obj).map(key => {
						if (Array.isArray(obj[key])) {
							this.mapkeyName(obj[key]);
						}
					});
				});

				return this.map;
			}
		},
		createCsvJson(tableData) {
			var headings = tableData.data.headings;
			var subHeadings = tableData.data.subHeadings;
			if (tableData.data.headings.length) {
				var result = tableData.data.rows.map(row => {
					var mappedArray = row.map((element, count) => {
						return {
							[headings[count] && headings[count].value]: element.value
						};
					});
					var obj = {};
					mappedArray.map((el, i) => {
						obj[[headings[i].value]] = el[headings[i].value];
					});
					return obj;
				});
				return result;
			} else {
				let name = subHeadings[0].value;
				var result = tableData.data.tableRows.map(ele => {
					let obj = {};
					obj[name] = ele.label;
					let newObj = {};
					ele.data.map((el, index) => {
						obj[subHeadings[index + 1].value + index] = el;
					});
					return obj;
				});

				return result;
			}
		},
		downloadCsv(names, selected_options, tableData) {
			if (
				this.$route.name == "forecastLocation" ||
				this.$route.name == "forecastCategory"
			) {
				if (selected_options == "day") {
					selected_options = "1 Day";
				}
				var export_csv = this.createCsvJson(tableData);
				// }
			} else {
				var export_csv = this.createCsvJson(tableData);
				console.log("tableData", this.createCsvJson(tableData));
				console.log("dwnlsdCsv", tableData);
			}
			// *****************download csv file************************************
			var csv = Papa.unparse(export_csv);
			var csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });

			var csvURL = null;
			if (navigator.msSaveBlob) {
				csvURL = navigator.msSaveBlob(csvData, "download.csv");
			} else {
				csvURL = window.URL.createObjectURL(csvData);
			}

			var tempLink = document.createElement("a");
			tempLink.href = csvURL;
			tempLink.setAttribute(
				"download",
				`${selected_options.Quick_Reports} ${selected_options.Date_From} To ${
					selected_options.Date_To
				} .csv`
			);
			tempLink.click();
		},
		cloneObject(obj) {
			var clone = {};
			for (var i in obj) {
				if (obj[i] != null && Array.isArray(obj[i])) clone[i] = obj[i];
				else if (obj[i] != null && typeof obj[i] == "object")
					clone[i] = this.cloneObject(obj[i]);
				else clone[i] = obj[i];
			}
			return clone;
		},
		lookup(name, stored_breadCrumbs) {
			var regex = /^\d{4}-\d{2}-\d{2}$/;
			for (var i in stored_breadCrumbs) {
				for (var key in stored_breadCrumbs[i]) if (key === name) return true;
			}
			return false;
		},
		getRegions(...args) {
			return CommonService.getRegions(...args).then(response => {
				return JSON.parse(response.data).results;
			});
		},
		getSubRegions() {
			return CommonService.getSubRegions().then(response => {
				return JSON.parse(response.data);
			});
		},
		getOutlets(args) {
			return CommonService.getOutlets(args).then(response => {
				return JSON.parse(response.data).results;
			});
		},
		getCountries(...args) {
			return CommonService.getCountries(...args).then(response => {
				return JSON.parse(response.data).results;
			});
		},
		getRegionsForParticularCountry(regionId, ...args) {
			return CommonService.getRegionsForParticularCountry(regionId, args).then(
				response => {
					return JSON.parse(response.data).results;
				}
			);
		},
		getSubregionsForParticularRegion(regionId, ...args) {
			return CommonService.getSubregionsForParticularRegion(
				regionId,
				args
			).then(response => {
				return JSON.parse(response.data).results;
			});
		},
		handleResetPageInfoEvent() {
			this.pageInfo.currentPage = 1;
			this.pageInfo.pageSize = 10;
		},
		handlePageInfoChange() {
			const fn = this.paginate();
			if (
				// if current page is greater than total pages then make the current page to the the last page.
				this.pageInfo.currentPage >
				this.pageInfo.totalCount / this.pageInfo.pageSize
			) {
				this.pageInfo.currentPage =
					Math.ceil(this.pageInfo.totalCount / this.pageInfo.pageSize) || 1;
			}
			fn(this.pageInfo);
		},

		readCsvFile(file, csvName) {
			return new Promise(function(complete, error) {
				Papa.parse(file, {
					header: true,
					dynamicTyping: true,
					skipEmptyLines: true,
					complete,
					error
				});
			});
		},
		closeProcessRunningPrompt() {
      this.store_processing_completed = false;
    }
	}
};
